import React, { useEffect } from "react";
import styled from "styled-components";
import Loader from "../../../Generic/Loader";
import useMachines from "../../../util/hooks/useMachines";

const PickerWrap = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	min-width: min(28rem, 80vw);
`;

const ResultsList = styled.ul`
	list-style: none;
	margin: 0;
	padding: 0;
	max-height: 16rem;
	overflow-y: auto;
	background: #fff;
	border: 1px solid rgba(0, 0, 0, 0.15);
	border-radius: 8px;
`;

const ResultItem = styled.li`
	padding: 0.75rem 1rem;
	cursor: ${(props) => (props.$disabled ? "default" : "pointer")};
	opacity: ${(props) => (props.$disabled ? 0.45 : 1)};
	border-bottom: 1px solid rgba(0, 0, 0, 0.08);
	color: #36395a;
	min-width: 0;

	&:last-child {
		border-bottom: none;
	}

	&:hover {
		background: ${(props) => (props.$disabled ? "#fff" : "#f1f1f1")};
	}
`;

const MachineInfo = styled.div`
	display: flex;
	flex-direction: column;
	min-width: 0;
	gap: 0.2rem;
`;

const MachineId = styled.div`
	color: #000;
	font-size: 1rem;
	font-weight: 600;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

const MachineName = styled.div`
	color: rgba(45, 35, 66, 0.55);
	font-size: 0.8rem;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

const StatusText = styled.p`
	margin: 0;
	color: rgba(0, 0, 0, 0.55);
	font-size: 0.9rem;
	text-align: center;
	padding: 1rem 0;
`;

const LoaderWrap = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 1rem 0;
`;

const MachineSelectModal = ({ isOpen, selectedIds = [], onAdd }) => {
	const { machines, loaded, loading, reload } = useMachines();
	const selectedSet = new Set(selectedIds);

	useEffect(() => {
		if (isOpen && !loaded && !loading) reload();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isOpen]);

	const availableMachines = machines.filter((machine) => machine._id);

	return (
		<PickerWrap>
			{loading ? (
				<LoaderWrap>
					<Loader />
				</LoaderWrap>
			) : availableMachines.length === 0 ? (
				<StatusText>No restaurants found</StatusText>
			) : (
				<ResultsList>
					{availableMachines.map((machine) => {
						const alreadySelected = selectedSet.has(machine._id);
						return (
							<ResultItem
								key={machine._id}
								$disabled={alreadySelected}
								onClick={() => {
									if (alreadySelected) return;
									onAdd?.(machine._id);
								}}>
								<MachineInfo>
									<MachineId>{machine._id}</MachineId>
									{machine.name ? <MachineName>{machine.name}</MachineName> : null}
								</MachineInfo>
							</ResultItem>
						);
					})}
				</ResultsList>
			)}
		</PickerWrap>
	);
};

export default MachineSelectModal;
